module.exports = __webpack_public_path__ + "static/logo-d603e263ae26be8dc8def2368127ade3.svg";